import fullpage from 'fullpage.js';
import { gsap } from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { Draggable } from "gsap/Draggable";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";


import filters from './filter.js';
//import sliders from './sliders.js';


import 'slick-carousel';
import barba from '@barba/core';

gsap.registerPlugin(CSSRulePlugin, Draggable, ScrollToPlugin, ScrollTrigger);




(function( $ ) {



	function initSlider(){
		$(".slick-slider").slick({
		  	infinite: true,
		  	variableWidth: true,
		  	centerMode: true,
		  	dots: false,
		  	controls: true,
		  	appendArrows: $(".slick-slider__arrows"),
		  	appendDots: false,
			nextArrow: '<div class="carousel__next"><svg width="29" height="9" viewBox="0 0 29 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.7318 4.96284C28.9661 4.72852 28.9661 4.34862 28.7318 4.11431L24.9134 0.295931C24.6791 0.0616167 24.2992 0.0616167 24.0649 0.295931C23.8306 0.530246 23.8306 0.910145 24.0649 1.14446L27.459 4.53857L24.0649 7.93268C23.8306 8.167 23.8306 8.5469 24.0649 8.78121C24.2992 9.01553 24.6791 9.01553 24.9134 8.78121L28.7318 4.96284ZM0.615234 5.13857L28.3075 5.13857L28.3075 3.93857L0.615234 3.93857L0.615234 5.13857Z" fill="#152235"/></svg></div>',
			prevArrow: '<div class="carousel__prev"><svg width="29" height="9" viewBox="0 0 29 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.268194 4.03716C0.0338802 4.27148 0.0338802 4.65138 0.268194 4.88569L4.08657 8.70407C4.32089 8.93838 4.70078 8.93838 4.9351 8.70407C5.16941 8.46975 5.16941 8.08985 4.9351 7.85554L1.54099 4.46143L4.9351 1.06731C5.16941 0.832999 5.16941 0.4531 4.9351 0.218785C4.70078 -0.0155296 4.32089 -0.0155296 4.08657 0.218785L0.268194 4.03716ZM28.3848 3.86143H0.692459V5.06143H28.3848V3.86143Z" fill="#152235"/></svg></div>',
		});


		$(".employee-list.slider").slick({
		  	infinite: true,
		  	variableWidth: false,
		  	centerMode: true,
		  	dots: false,
			slidesToShow: 3,
		  	controls: true,
		  	appendArrows: $(".employee-list__arrows"),
		  	appendDots: false,
						prevArrow: '<div class="carousel__prev"><svg width="29" height="9" viewBox="0 0 29 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.268194 4.03716C0.0338802 4.27148 0.0338802 4.65138 0.268194 4.88569L4.08657 8.70407C4.32089 8.93838 4.70078 8.93838 4.9351 8.70407C5.16941 8.46975 5.16941 8.08985 4.9351 7.85554L1.54099 4.46143L4.9351 1.06731C5.16941 0.832999 5.16941 0.4531 4.9351 0.218785C4.70078 -0.0155296 4.32089 -0.0155296 4.08657 0.218785L0.268194 4.03716ZM28.3848 3.86143H0.692459V5.06143H28.3848V3.86143Z" fill="#ffffff"/></svg></div>',
		  	nextArrow: '<div class="carousel__next"><svg width="29" height="9" viewBox="0 0 29 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.7318 4.96284C28.9661 4.72852 28.9661 4.34862 28.7318 4.11431L24.9134 0.295931C24.6791 0.0616167 24.2992 0.0616167 24.0649 0.295931C23.8306 0.530246 23.8306 0.910145 24.0649 1.14446L27.459 4.53857L24.0649 7.93268C23.8306 8.167 23.8306 8.5469 24.0649 8.78121C24.2992 9.01553 24.6791 9.01553 24.9134 8.78121L28.7318 4.96284ZM0.615234 5.13857L28.3075 5.13857L28.3075 3.93857L0.615234 3.93857L0.615234 5.13857Z" fill="#ffffff"/></svg></div>',

			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						infinite: true,
						dots: true
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true
					}
				},

			]
		});
	}

	function initVideo(){

		$("body").on("click", ".play-button", function(e){
			e.preventDefault();
			 $(this).siblings("video").get(0).play();
			 $(this).siblings("video").attr({"controls": "1"})
			 $(this).addClass("--hide");
		});
	}











		 document.querySelectorAll('.--parallax-image').forEach(box => {
			gsap.to(box, {
				scrollTrigger: {
					trigger: $(box).parent()[0],
					scroller: "body",
					scrub: true,
					pin: false,
					start: "top bottom",
					end: "bottom top",
					markers: false,
					snap: 0
				},
				y:"0%",
				ease: "none"
			});

		});




		function initBlocks(){

			$(".--text-animation").each(function(i, el){

				/*const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: $(this).parents(".content-block")[0],
						start: "top bottom",
						scroller: "body",
						end: "bottom top",
						onToggle: self => gsap.to(el, {opacity: self.isActive ? 1 : 0}),
						toggleActions: "restart pause resume none",
						markers: false
					}
				});

				if($(el).hasClass("--lines")){

					//var mySplitText2 = nestedLinesSplit(el, {type:"lines", linesClass: "lineWrapper" });
					//var mySplitText = nestedLinesSplit(el, {type:"lines", linesClass: "lines" });
					const split = new SplitText(el, { type: "lines"});


					splitTimeline.from(split.lines, {
					  duration: 0.5,
					  opacity: 0,
					  y: "20px",
					  scale: 1,
					  yoyo: false,
					  stagger: 0.2
					});
				}
				else{


					const split = new SplitText(el, { type: "words"});


					splitTimeline.from(split.words, {
					  duration: 0.5,
					  opacity: 0,
					  y: "20px",
					  scale: 1,
					  yoyo: false,
					  stagger: 0.05
					});
				}*/

			});

		}


		function headerScroll(){
			var y = $("body").scrollTop();
			var winH = $(window).height();
			if(y > 20){
				$(".header:not(.--scrolled)").addClass("--scrolled");
			}
			else{
				$(".header.--scrolled").removeClass("--scrolled");
			}
			if($('.home').length === 0) {
				if(y > winH){
					$(".popup:not(.--visible)").addClass("--visible");
				}
			}
			else{
				$(".popup:not(.--visible)").addClass("--visible");
			}
		}


		function homeSliderScroll(){
			var y = $("body").scrollTop();
			var winH = $(window).height();
			if(y < winH){
				var perc = y/winH;
			}
			else{
				var perc = 1;
			}
			var scale = 1+(perc/4);
			var translate = (perc/4)*winH;
			$("#home-slider li .image img").css({"transform": "translate(0, "+translate+"px) scale("+scale+")"});
		}



		function initHomeSlider(){
			var homesliderI = 1;
			$("#home-slider").attr("slide-index", homesliderI);
			var homesliderSlides = $("#home-slider-navigation li").length;
			function homeSliderSlideTo(s){

				$("#home-slider-navigation li").removeClass("active");
				$("#home-slider-navigation li:nth-child("+s+")").addClass("active");
				$("#home-slider li").removeClass("active");
				$("#home-slider li:nth-child("+s+")").addClass("active");
				$("#home-slider").attr("slide-index", s);

			}
			$("body").on("click", "#home-slider-navigation li:not(.active)", function(e){
				var s = $(this).prevAll().length;
				homeSliderSlideTo(s+1);
			});
			$("body").on("click", "#home-slider-arrow-right", function(e){
				var homesliderI = parseFloat($("#home-slider").attr("slide-index"));
				var homesliderI = homesliderI+1;
				if(homesliderI == homesliderSlides+1){
					var homesliderI = 1;
				}
				homeSliderSlideTo(homesliderI);
			});
			$("body").on("click", "#home-slider-arrow-left", function(e){
				var homesliderI = parseFloat($("#home-slider").attr("slide-index"));
				var homesliderI = homesliderI-1;
				if(homesliderI <= 1){
					var homesliderI = homesliderSlides;
				}
				homeSliderSlideTo(homesliderI);
			});
		}



		function initPopup(){
			//if (localStorage.getItem("hidepopup") !== null) {
			//	$(".popup").remove();
			//}
			$("body").on("click", ".popup .close", function(e){
				e.preventDefault();
				$(".popup").remove();
				localStorage.setItem("hidepopup", true);
			});
		}


		function splitText(){
			document.querySelectorAll('.first h1, .content-block h2').forEach(box => {
				var tl = gsap.timeline(),
				mySplitText = new SplitText(box, {type:"lines"}),
				chars = mySplitText.chars;
			});
		}




		$(".--text-animation").each(function(i, el){

			if($(el).hasClass("--lines")){
				//var mySplitText2 = nestedLinesSplit(el, {type:"lines", linesClass: "lineWrapper" });
				//var mySplitText = nestedLinesSplit(el, {type:"lines", linesClass: "lines --load-animation" });
			}
			else{
				//new SplitText(el, { type: "words", wordsClass: "wordWrapper" });
		    	//new SplitText(el, { type: "words", wordsClass: "word --load-animation" });
			}

		});









		function init(){
			initSlider();
			initHomeSlider();
			headerScroll();
			homeSliderScroll();
			initVideo();
			initPopup();
			initBlocks();
			//initScroll();
			splitText();
			filters( $ );

			$(window).on("resize", function() {

				homeSliderScroll();
				headerScroll();
			});
			$("body").on("scroll", function(e){
				homeSliderScroll();
				headerScroll();
			});
		}


		$(window).on("load", function() {

		});

		init();



		$("body").on("click", "#responsive-navigation-button", function(e){
			$("#responsive-menu-overlay").toggleClass("show");
		});
		$("body").on("click", "#responsive-menu-overlay .close", function(e){
			$("#responsive-menu-overlay").toggleClass("show");
		});


		$("body").on("click", "#js-scroll-down", function(e){
			$(this).parents(".content-block").next().attr("id", "scroll-to");
			var dis = $("#scroll-to").offset().top+$("body").scrollTop();
			$("html, body").animate({ scrollTop: dis }, 600);
		});





		window.mobileCheck = function() {
		   let check = false;
		   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		   return check;
		};


		function nestedLinesSplit(target, vars) {
			var split = new SplitText(target, vars),
			    words = (vars.type.indexOf("words") !== -1),
			    chars = (vars.type.indexOf("chars") !== -1),
			    insertAt = function(a, b, i) { //insert the elements of array "b" into array "a" at index "i"
			        var l = b.length,
			            j;
			        for (j = 0; j < l; j++) {
			            a.splice(i++, 0, b[j]);
			        }
			        return l;
			    },
			    children, child, i;

			if (typeof(target) === "string") {
			    target = document.querySelectorAll(target);
			}
			if (target.length > 1) {
			    for (i = 0; i < target.length; i++) {
			        split.lines = split.lines.concat(nestedLinesSplit(target[i], vars).lines);
			    }
			    return split;
			}

			//mark all the words and character <div> elements as _protected so that we can identify the non-split stuff.
			children = (words ? split.words : []).concat(chars ? split.chars : []);
			for (i = 0; i < children.length; i++) {
			    children[i]._protect = true;
			}

			children = split.lines;
			for (i = 0; i < children.length; i++) {
			    child = children[i].firstChild;
			    //if the first child isn't protected and it's not a text node, we found a nested element that we must bust up into lines.
			    if (!child._protect && child.nodeType !== 3) {
			        children[i].parentNode.insertBefore(child, children[i]);
			        children[i].parentNode.removeChild(children[i]);
			        children.splice(i, 1);
			        i += insertAt(children, nestedLinesSplit(child, vars).lines, i) - 1;
			    }
			}
			return split;
		}





} ) ( jQuery );
